import Vue from 'vue';
import Vuex from 'vuex';
import * as fb from './firebase';
import update from 'immutability-helper';
import authenticatedRequest from './lib/authenticatedRequest';
import { clearSignupInProgress } from './lib/signupSession';
import router from './router';
import isAfter from 'date-fns/isAfter';
import parseISO from 'date-fns/parseISO';

Vue.use(Vuex);

function normalizeHolder(raw) {
	return Array.isArray(raw) ? raw[0] : raw;
}

const PRESENCE_HEARTBEAT_MS = 20000;
const PRESENCE_STALE_MS = 60000;

const store = new Vuex.Store({
	state: {
		activeUser: {},
		agreement: {},
		agreements: [],
		permissions: {},
		editedAgreement: null,
		editedSummaryAgreement: null,
		editedSummaryAgreementWithDiscardedSuggestions: null,
		editedAgreementWithDiscardedSuggestions: null,
		events: [],
		featureflags: [],
		remoteConfigVersion: 0,
		loading: true,
		saving: false,
		plans: [],
		plansLoaded: false,
		subscriptions: null,
		payments: null, // One-time payments for party users
		user: {},
		userProfile: {},
		agreementUnsubscribe: null,
		userProfileUnsubscribe: null,
		paymentsUnsubscribe: null,
		unsubscribeActiveUser: null,
		amActiveHolder: false,
		idToken: null,
		presenceTimer: null,
		childSupportTables: null,
		loginProvider: null,
		showPermissionDeniedPage:false,
		lawyerUid: null,
		currentRoleLevel:null,
		sessionResolved:false,
		signingUp:false,
		roleLevels:[],
		userRole: [],
		currentLoginPageNo:1,
		currentSignUpPageNo:1,
		clientUserAgreement:null,
		showAgreementTrialExpired: false,
		isLoggingOut: false,
		currentAgreementRoleLevelName:null,
		storeIsSharedUser: null,
		isEditorUnresolved: false,
		showAgreementTrialExpired: false,
		customerDetails:null,
		posthogRole: null,
		revisions: [],
		revisionFlushCallback: null,
	},
	mutations: {
		setPosthogRole(state, role) {
			state.posthogRole = role;
		},
		setLoginProvider(state, loginProvider){
			state.loginProvider = loginProvider;
			localStorage.setItem('loginProvider', state.loginProvider);
		},
		setActiveUser(state, activeUser) {
			state.activeUser = activeUser;
		},
		setAmActiveHolder(state, value) {
			state.amActiveHolder = value;
		},
		setIdToken(state, token) {
			state.idToken = token;
		},
		setPresenceTimer(state, timer) {
			state.presenceTimer = timer;
		},
		setLoading(state, loading) {
			state.loading = loading;
		},
		bumpRemoteConfigVersion(state) {
			state.remoteConfigVersion += 1;
		},
		setPermissionDeniedPage(state, permissionDenied) {
			state.showPermissionDeniedPage = permissionDenied;
		},
		setSaving(state, saving) {
			state.saving = saving;
		},
		setUserProfile(state, userProfile) {
			state.userProfile = userProfile;
		},
		setAgreement(state, val) {
			state.agreement = val;
		},
		setPermissions(state, val) {
			state.permissions = val;
		},
		setUser(state, val) {
			state.user = val;
		},
		setAgreements(state, agreements) {
			state.agreements = agreements || [];
		},
		setPlans(state, plans) {
			state.plans = plans;
		},
		setPlansLoaded(state, loaded) {
			state.plansLoaded = loaded;
		},
		setSubscriptions(state, subscriptions) {
			state.subscriptions = subscriptions;
		},
		setPayments(state, payments) {
			state.payments = payments;
		},
		setEvents(state, events) {
			state.events = events;
		},
		setEditedAgreement(state, editedAgreement) {
			state.editedAgreement = editedAgreement;
		},
		setSummaryAgreement(state, editedSummaryAgreement) {
			state.editedSummaryAgreement = editedSummaryAgreement;
		},
		setUnsubscribeUserProfile(state, unsubscribe) {
			state.userProfileUnsubscribe = unsubscribe;
		},
		setUnsubscribePayments(state, unsubscribe) {
			state.paymentsUnsubscribe = unsubscribe;
		},
		setUnsubscribeAgreement(state, unsubscribe) {
			state.agreementUnsubscribe = unsubscribe;
		},
		setUnsubscribeActiveUser(state, unsubscribe) {
			state.unsubscribeActiveUser = unsubscribe;
		},
		setChildSupportTables(state, val) {
			state.childSupportTables = val;
		},
		setlawyerUid(state , id){ 
			state.lawyerUid = id
		},
		setCurrentRoleLevel(state , roleLevel){ 
			state.currentRoleLevel = roleLevel;
			if(roleLevel)
				localStorage.setItem('currentRoleLevel', JSON.stringify(roleLevel));
			else
				localStorage.removeItem('currentRoleLevel');
		},
		setSessionResolved(state, value){
			state.sessionResolved = value;
		},
		setSigningUp(state, value){
			state.signingUp = value;
		},
		setAllRoleLevels(state , roleLevels){ 
			state.roleLevels = roleLevels
		},
		setCurrentRole(state, role) {
			state.currentRole = role;
		},
		setUserRole(state, val){
			state.userRole = val;
		},
		setCurrentLoginPageNo(state, val){
			state.currentLoginPageNo = val;
		},
		setCurrentSignUpPageNo(state, val){
			state.currentSignUpPageNo = val;
		},
		setClientUserAgreement(state, val){
			if(val){
				localStorage.setItem('clientUserAgreement',val);
			} else {
				localStorage.removeItem('clientUserAgreement');
			}
			state.clientUserAgreement = val;
		},
		setEditedAgreementWithDiscardedSuggestions(state, val) {
			state.editedAgreementWithDiscardedSuggestions = val;
		},
		setCurrentRoleLevelName(state, val) {
			state.currentAgreementRoleLevelName = val;
		},
		setShowAgreementTrialExpired(state, val) {
			state.showAgreementTrialExpired = val;
		},
		setStoreIsSharedUser(state, val){
			localStorage.setItem("storeIsSharedUser",val)
			state.storeIsSharedUser = val
		  },
		setIsEditorUnresolved(state, val){
			state.isEditorUnresolved = val
		},
		setSummaryAgreementWithDiscardedSuggestions(state, val) {
			state.editedSummaryAgreementWithDiscardedSuggestions = val;
		},
		setLoggingOut(state, value) {
			state.isLoggingOut = value;
		},
		setCustomerDetails(state, value) {
			state.customerDetails = value;
		},
		setRevisions(state, revisions) {
			state.revisions = revisions || [];
		},
		setRevisionFlushCallback(state, callback) {
			state.revisionFlushCallback = callback;
		},
	},
	getters: {
		isAuthenticated: (state) =>
			state.user && state.user.uid ? true : false,
		loading: ({ loading }) => loading,
		agreementDetails: ( state ) => state.agreement,
		userRolePermissions: ( state ) => state.userRole,
		getCurrentRoleLevel(state) {
			return state.currentRoleLevel || (localStorage.getItem('currentRoleLevel') && JSON.parse(localStorage.getItem('currentRoleLevel'))) || null;
		},
		clientUserAgreement(state) {
			return state.clientUserAgreement || (localStorage.getItem('clientUserAgreement') && JSON.parse(localStorage.getItem('clientUserAgreement'))) || null;
		},
		activePaymentForSeparatingParty(state) {
			// For party users, check payments collection (one-time payments)
			if (state.payments && state.payments.length > 0) {
				// Get the first succeeded payment
				const payment = state.payments[0];
				// Fallback: match price ID against plans to get plan type
				if (state.plans && state.plans.length > 0) {
					const paymentPriceId = payment.items?.[0]?.price?.id;
					if (paymentPriceId) {
						for (const plan of state.plans) {
							if (plan.prices && Array.isArray(plan.prices)) {
								const matchingPrice = plan.prices.find(price => price.id === paymentPriceId);
								if (matchingPrice) {
									// Return the plan type from the plan's metadata
									return plan.stripe_metadata_plan || null;
								}
							}
						}
					}
				}
			}

			return null;
		},
	},
	actions: {
		setCurrentRole({ commit }, role) {
			commit('setCurrentRole', role);
		},
		async login({ commit, dispatch, state }, user) {
			if (/@divii.ca\s*$/.test(user.email)) {
				fb.analytics.setUserProperties({ admin: true });
			}
			fb.analytics.setUserProperties({ userId: user.uid });
			const { claims } = await fb.auth.currentUser.getIdTokenResult();

			// save user data
			commit('setUser', { ...user, claims });
			commit('setPermissionDeniedPage', false);

			let role = state.currentRole || 'unknown';
			try {
				const custDetails = await fb.customersCollection.doc(user.uid).get();
				if (custDetails.exists && custDetails.data()?.roleAssociated) {
					role = custDetails.data().roleAssociated;
					commit('setPosthogRole', role);
				}
			} catch (error) {
				console.error('Failed to fetch posthogRole:', error);
			}
			if (role === 'unknown') {
				let pathname = null;

				try {
				const posthogProperties = Vue.prototype.$posthog.get_session_replay_properties?.() || {};
				pathname = posthogProperties.$pathname || null;
				if (!pathname) {
					const capturedProperties = Vue.prototype.$posthog.get_property?.('$pathname');
					pathname = capturedProperties || null;
				}
				} catch (error) {
				console.error('Failed to fetch PostHog $pathname:', error);
				}

				if (!pathname) {
				try {
					pathname = this._vm.$route.path;
				} catch (error) {
					console.error('Failed to fetch Vue Router path:', error);
					pathname = '/auth';
				}
				}

				if (pathname === '/auth') {
				role = 'lawyer';
				} else if (pathname === '/couple/auth') {
				role = 'party';
				}
				console.log(`Inferred role from pathname (${pathname}): ${role}`);
				commit('setPosthogRole', role);
			}

			Vue.prototype.$posthog.capture('user_login', {
				user_id: user.uid,
				role: role || '',
				email: user.email,
			});
			// fetch user profile and set in state
			dispatch('fetchUserProfile', user);
		},
		// async fetchLoginProvider({ state, commit }){
		// 	try{
		// 		const loginProvider = state.loginProvider;
				// commit('setLoginProvider', loginProvider);
		// 	} catch (error) {
		// 		console.error('Error fetch Login Provider', error);
		// 	}
		// },
		resetUser({ state, commit }) {
			commit('setUser', null);
			commit('setAgreements', []);
			commit('setUserProfile', []);
			clearSignupInProgress();
			commit('setSessionResolved', false);
			commit('setSigningUp', false);
			commit('setLoading', false);
			commit('setSubscriptions', null);
			commit('setPayments', null);
			commit('setPosthogRole', null);

			if (state.userProfileUnsubscribe) state.userProfileUnsubscribe();
			commit('setUnsubscribeUserProfile', null);

			if (state.paymentsUnsubscribe) state.paymentsUnsubscribe();
			commit('setUnsubscribePayments', null);

			// Reset the agreement as well.
			this.dispatch('resetAgreement');
		},
		resetAgreement({ commit, state }) {
			commit('setAgreement', {});
			commit('setPermissions', {});
			commit('setEvents', []);
			commit('setEditedAgreement', null);
			commit('setSummaryAgreement', null);
			commit('setEditedAgreementWithDiscardedSuggestions', null);
			commit('setSummaryAgreementWithDiscardedSuggestions', null);
			if (state.agreementUnsubscribe) state.agreementUnsubscribe();
			if (state.unsubscribeActiveUser) state.unsubscribeActiveUser();
			if (state.presenceTimer) clearInterval(state.presenceTimer);
			commit('setUnsubscribeAgreement', null);
			commit('setUnsubscribeActiveUser', null);
			commit('setPresenceTimer', null);
			commit('setActiveUser', {});
			commit('setAmActiveHolder', false);
		},
		async logout({ commit, dispatch, state }) {
				let role = state.posthogRole || 'unknown';

				if (state.user && state.user.uid) {
					Vue.prototype.$posthog.capture('user_logout', {
						user_id: state.user.uid,
						role: role,
						email: state.user.email || '',
						timestamp: new Date().toISOString(),
					});
				}
				commit('setLoggingOut', true);
				if (state.agreement?.id) {
					await dispatch('clearActiveUser', state.agreement.id);
				}
				await dispatch('clearConditionalStorageValues');

				// Flush editor session revision before signOut so Firestore writes
				// still pass auth rules. 3s cap so a hung Firestore never blocks logout.
				if (typeof state.revisionFlushCallback === 'function') {
					try {
						await Promise.race([
							Promise.resolve(state.revisionFlushCallback()),
							new Promise((resolve) => setTimeout(resolve, 3000)),
						]);
					} catch (error) {
						console.error('[logout] revision flush failed:', error);
					}
				}

				await fb.auth.signOut();

				await dispatch('resetUser');
				localStorage.removeItem('lawyerUid');

			// Setting a timestamp for logout event
			localStorage.setItem('forceLogout', Date.now().toString());
				
		},
		clearConditionalStorageValues({ commit }){
			localStorage.removeItem('cliotoken');
			localStorage.removeItem('clioUser');
			localStorage.removeItem('loginProvider');
			localStorage.removeItem('isAssetView');
			localStorage.removeItem('currentDisplayMode');
			commit('setCurrentRoleLevel', null);
			localStorage.removeItem('redirectRouteParams');
			localStorage.removeItem('isClioFetch');
			localStorage.removeItem('loggedInEmailID');
			localStorage.removeItem('showGoogleLoginConfirmation');
			localStorage.removeItem('isAssetView');
			localStorage.removeItem('summaryPageCheck');
			localStorage.removeItem('displayName');
			localStorage.removeItem('userLastName');
			localStorage.removeItem('phoneNumber');
			localStorage.removeItem('organizationName');
			localStorage.removeItem('locationOfPractice');
			sessionStorage.removeItem('activeIndex');
			sessionStorage.removeItem('activeTab');
		},
		async fetchUserProfile({ commit, state, dispatch }, user) {
			// fetch user profile
			// console.log('user.uid ->',user.uid)
			commit('setLoading', true);
			console.log('user ->',user);
			if(user?.email)
				localStorage.setItem('loggedInEmailID',user.email);
			if (!state.roleLevels || !state.roleLevels.length) {
				await dispatch('getAllRoleLevels');
			}
			await setRoleLevelForLoggedInUser(commit,state,user);
			const unsubscribe = fb.usersCollection.doc(user.uid).onSnapshot(
				async (userProfile) => {
					const { agreements, ...userProfileData } =
						userProfile.data() || {};
					// set user profile in state
					commit('setUserProfile', userProfileData);

					if (userProfileData.requiresPayment === true && !state.payments) {
						await dispatch('getPayments', user);
					}

					commit('setSessionResolved', true);

					const normalizedAgreements = Array.isArray(agreements)
						? agreements.map((agreement) => {
								// preserve backend flag if already present
								if (typeof agreement.owner === 'boolean') {
									return agreement;
								}

								const createdBy =
									agreement?.createdBy || agreement?.created_by;
								return {
									...agreement,
									owner: createdBy
										? createdBy === user?.uid
										: false,
								};
						  })
						: [];

					commit('setAgreements', normalizedAgreements);

					this.checkAndRetrieveAgreementOnClientUserLogin;
					if (state.loading) {
						fb.remoteConfig
							.fetchAndActivate()
							.then(() => {
								commit('bumpRemoteConfigVersion');
								commit('setLoading', false);
							})
							.catch((err) => {
								console.error(err);
								commit('bumpRemoteConfigVersion');
								commit('setLoading', false);
							});
					}
				},
				(error) => {
					console.error(
						`Encountered error fetching user profile: ${error}`
					);
				}
			);
			commit('setUnsubscribeUserProfile', unsubscribe);
		},
		async fetchAgreement({ commit, state }, { id, realtime = false }) {
			commit('setShowAgreementTrialExpired',false)
			commit('setPermissionDeniedPage', false);
			const agreementRef = fb.agreementsCollection.doc(id);
			const permissionsRef = agreementRef
				.collection('users')
				.doc('permissions');
			console.log('permissionsRef==>',permissionsRef);
			if (realtime) {
				const unsubscribe = agreementRef.onSnapshot(
					(agreement) => {
						console.log('agreement.data()==>',agreement.data());
						commit('setAgreement', { ...agreement.data(), id });
					},
					(error) => {
						console.error(
							`Encountered error fetching agreement: ${error}`
						);
					}
				);
				commit('setUnsubscribeAgreement', unsubscribe);
			} else {
				try {
					const [agreement, permissions] = await Promise.all([
						agreementRef.get(),
						permissionsRef.get(),
					]);
					console.log('agreement==>',agreement);
					console.log('permissions==>',permissions);
					const uid = () =>
					Object.values(permissions.data()).filter(({ primaryLawyer }) => primaryLawyer === true);
					localStorage.setItem("lawyerUid", uid()[0].uid)
					let userEmail=localStorage.getItem('loggedInEmailID');

				// const userRef = fb.usersCollection.doc(uid()[0].uid);
				// const primaryLawyerProfile = await userRef.get();
				// const { trialEnd, subscriptionStatus } = primaryLawyerProfile.data()
				const response = await authenticatedRequest("GET", `/user/${uid()[0].uid}`);
				const primaryLawyerProfile = response?.data?.user;

				const { trialEnd, subscriptionStatus } = primaryLawyerProfile;
				// Only treat as subscribed if subscriptionStatus is actually 'active' or true
				// 'canceled' or other truthy values should not be treated as active subscription
				const hasActiveSubscription = subscriptionStatus === true || subscriptionStatus === 'active';
				const isPrimaryLawyerTrialExpired = hasActiveSubscription ? false : trialEnd && !isAfter(parseISO(trialEnd), new Date());
				const userPermissionCheck = () =>
				Object.values(permissions.data()).filter(({ email }) => email === userEmail);
				console.log("userPermissionCheck:", userPermissionCheck()[0])
				if(isPrimaryLawyerTrialExpired && !state.userProfile.subscriptionStatus) {
					commit('setShowAgreementTrialExpired',true)
				}
					else{
						commit('setShowAgreementTrialExpired',false)
					}

					if(!userPermissionCheck()[0]){
						// window.location.reload();
						commit('setPermissionDeniedPage', true);
					}else{
						commit('setPermissionDeniedPage', false);
					}
					commit('setlawyerUid', uid()[0].uid);

				// Clean up previous activeUser subscription and state before loading new agreement
				if (state.unsubscribeActiveUser) {
					state.unsubscribeActiveUser();
					commit('setUnsubscribeActiveUser', null);
				}
				if (state.presenceTimer) {
					clearInterval(state.presenceTimer);
					commit('setPresenceTimer', null);
				}
				commit('setAmActiveHolder', false);
				commit('setActiveUser', {}); // Clear previous activeUser state

					// set active agreement & permissions in state - don't forget to reset on logout or changing an agrement.
					commit('setAgreement', { ...agreement.data(), id });
					commit('setPermissions', permissions.data());
					this.dispatch('watchActiveUser', id);
				} catch (error) {
					// if(localStorage.getItem('clientUserAgreement') && error.code =='permission-denied'){
					// 	commit('setPermissionDeniedPage', true);
					// }
					console.error(error.code);
					if(error.code =='permission-denied'){
						commit('setPermissionDeniedPage', true);
					}else{
						commit('setPermissionDeniedPage', false);
					}
				}
			}
		},
		async fetchAgreementForDuplicate(_, id) {
			const doc = await fb.agreementsCollection.doc(id).get();
			return doc.exists ? doc.data() : null;
		},
		async copyScheduleDocs(_, { sourceId, targetId }) {
			const paths = [['parentingSchedule', 'draft'], ['holidaySchedule', 'draft'], ['planner', 'schedule']];
			await Promise.all(paths.map(async ([collection, doc]) => {
				const snap = await fb.agreementsCollection.doc(sourceId).collection(collection).doc(doc).get();
				if (snap.exists) {
					await fb.agreementsCollection.doc(targetId).collection(collection).doc(doc).set(snap.data());
				}
			}));
		},
		async fetchPermissions({ commit, state }) {
			try {
				const permissions = await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('users')
					.doc('permissions')
					.get();
				commit('setPermissions', permissions.data());
			} catch (error) {
				console.error(error);
			}
		},
		watchActiveUser({ commit, state, dispatch }, agreementId) {
			const unsubscribe = fb.agreementsCollection
				.doc(agreementId)
				.collection('users')
				.doc('active')
				.onSnapshot(
					(activeUserSnap) => {
						const data = activeUserSnap.data();
						const holder = normalizeHolder(data && data.user);
						const myUid = state.user && state.user.uid;
						const lastSeenMs =
							data && data.lastSeen && data.lastSeen.toMillis
								? data.lastSeen.toMillis()
								: 0;
						const fresh =
							lastSeenMs > 0 &&
							Date.now() - lastSeenMs < PRESENCE_STALE_MS;
						// Blocked only by a live holder; a stale one is a ghost.
						if (holder && myUid && holder !== myUid && fresh) {
							commit('setAmActiveHolder', false);
							commit('setActiveUser', { user: holder });
						} else {
							// Free, mine, or stale ghost → take/keep the lock.
							if (myUid && holder !== myUid && !state.isLoggingOut) {
								dispatch('setActiveUser', agreementId);
							}
							commit('setAmActiveHolder', !!myUid && holder === myUid);
							commit('setActiveUser', {});
						}
					},
					(error) => {
						console.error(
							`Encountered error fetching agreement active user: ${error}`
						);
						if (error.code == 'permission-denied') {
							commit('setPermissionDeniedPage', true);
						} else {
							commit('setPermissionDeniedPage', false);
						}
					}
				);
			commit('setUnsubscribeActiveUser', unsubscribe);
			// Snapshots don't fire when a crashed holder goes silent — the timer
			// is what lets a blocked watcher notice staleness and reclaim.
			dispatch('startPresenceTimer', agreementId);
		},
		async setActiveUser({ state }, agreementId) {
			const uid = state.user && state.user.uid;
			if (!uid) return;
			try {
				await fb.agreementsCollection
					.doc(agreementId)
					.collection('users')
					.doc('active')
					.set({ user: uid, lastSeen: fb.FieldValue.serverTimestamp() });
			} catch (error) {
				console.error(error);
			}
		},
		// Release the lock only if I hold it (graceful exits: route change, logout).
		async clearActiveUser({ state }, agreementId) {
			const uid = state.user && state.user.uid;
			if (!uid) return;
			const ref = fb.agreementsCollection
				.doc(agreementId)
				.collection('users')
				.doc('active');
			try {
				await fb.db.runTransaction(async (tx) => {
					const snap = await tx.get(ref);
					const holder = normalizeHolder(snap.data() && snap.data().user);
					if (holder === uid) tx.set(ref, { user: null });
				});
			} catch (error) {
				console.error(error);
			}
		},
		// Release on tab close: keepalive fetch survives teardown (a normal SDK
		// write gets cancelled). Only fires when I hold the lock.
		clearActiveUserBeacon({ state }) {
			const uid = state.user && state.user.uid;
			const agreementId = state.agreement && state.agreement.id;
			const token = state.idToken;
			if (!uid || !agreementId || !token || !state.amActiveHolder) return;
			const projectId = process.env.VUE_APP_FIREBASE_PROJECT_ID;
			const url =
				`https://firestore.googleapis.com/v1/projects/${projectId}` +
				`/databases/(default)/documents/agreements/${agreementId}` +
				`/users/active?updateMask.fieldPaths=user`;
			try {
				fetch(url, {
					method: 'PATCH',
					keepalive: true,
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${token}`,
					},
					body: JSON.stringify({ fields: { user: { nullValue: null } } }),
				}).catch(() => {});
			} catch (error) {
				// best-effort only
			}
		},
		// Heartbeat while I hold the lock; reclaim a free/stale lock while I don't.
		startPresenceTimer({ state, commit }, agreementId) {
			if (state.presenceTimer) clearInterval(state.presenceTimer);
			const ref = fb.agreementsCollection
				.doc(agreementId)
				.collection('users')
				.doc('active');
			const timer = setInterval(async () => { 
				const uid = state.user && state.user.uid;
				if (!uid || state.isLoggingOut) return;
				try {
					if (state.amActiveHolder) {
						await ref.update({
							lastSeen: fb.FieldValue.serverTimestamp(),
						});
					} else {
						await fb.db.runTransaction(async (tx) => {
							const snap = await tx.get(ref);
							const d = snap.data();
							const holder = normalizeHolder(d && d.user);
							const lastSeenMs =
								d && d.lastSeen && d.lastSeen.toMillis
									? d.lastSeen.toMillis()
									: 0;
							const fresh =
								lastSeenMs > 0 &&
								Date.now() - lastSeenMs < PRESENCE_STALE_MS;
							if (!holder || holder === uid || !fresh) {
								tx.set(ref, {
									user: uid,
									lastSeen: fb.FieldValue.serverTimestamp(),
								});
							}
						});
					}
				} catch (error) {
					console.error(error);
				}
			}, PRESENCE_HEARTBEAT_MS);
			commit('setPresenceTimer', timer);
		},
		async createAgreement({ state }, agreement) {
			try {
				if(state.user){
				const {
					data: { id },
				} = await authenticatedRequest('POST', '/agreements', {
					agreement,
					uid: state.user.uid,
				});

				// If we know at this point if this user has assistants or an Organization like thing could post to addAssistant here.
				// could make a bulk endpoint later or a background function to do this automatically

				// TODO error handle
				return { id };
			    }
			} catch (error) {
				console.error(error);
				return { error };
			}
		},
		async updateAgreement({ state, commit }, agreement) {
			if (!agreement.id) return;
			if (process.env.NODE_ENV === 'development')
				console.log('update agreement');

			commit('setSaving', true);
			const now = new Date().toISOString();

			await fb.agreementsCollection.doc(agreement.id).set({
				updatedAt: now,
				...agreement,
			});

			Vue.prototype.$posthog.capture('agreement_updated', {
				agreement_id: agreement.id,
				user_id: store.state.user?.uid,
				role: store.state.posthogRole || '',
				status: agreement.status,
				email: store.state.user.email
			});

			if (agreement.status === 'completed') {
				Vue.prototype.$posthog.capture('agreement_completed', {
				agreement_id: agreement.id,
				user_id: store.state.user?.uid,
				role: store.state.posthogRole || '',
				email: store.state.user.email
				});
			}

			setTimeout(() => {
				commit('setSaving', false);
			}, 500);
		},
		updateAgreementProperty({ state }, { property, value }) {
			const updatedAgreement = update(state.agreement, {
				[property]: { $set: value },
			});

			this.dispatch('updateAgreement', updatedAgreement);
		},
		async updateAgreementFields({ state, commit }, { id, fields }) {
			if (!id) return;
			if (process.env.NODE_ENV === 'development')
				console.log('update agreement fields', fields);

			commit('setSaving', true);
			const now = new Date().toISOString();

			// Use .update() for partial field updates to avoid overwriting other fields
			await fb.agreementsCollection.doc(id).update({
				updatedAt: now,
				...fields,
			});

			// Fetch fresh agreement data from Firestore to ensure we don't have stale data
			const freshAgreement = await fb.agreementsCollection.doc(id).get();
			commit('setAgreement', freshAgreement.data());

			setTimeout(() => {
				commit('setSaving', false);
			}, 500);
		},
		async deleteAgreement(_, agreementId) {
			const now = new Date().toISOString();
			try {
				await fb.agreementsCollection.doc(agreementId).set(
					{
						updatedAt: now,
						archived: now,
					},
					{ merge: true }
				);
				Vue.prototype.$posthog.capture('agreement_deleted', {
					agreement_id: agreementId,
					user_id: store.state.user?.uid,
					role: store.state.posthogRole || '',
					email: store.state.user.email
				});
			} catch (error) {
				console.error(
					`There was a problem archiving agreement ${agreementId}`,
					error
				);
			}
		},
		async deleteMultipleAgreements(_, agreementIds) {
			const now = new Date().toISOString();
			try {
			for(let i=0; i<agreementIds.length;i++){
				await fb.db.runTransaction(async (transaction) => {
				  const agreementRef = fb.agreementsCollection.doc(agreementIds[i]);
				   transaction.set(agreementRef, { updatedAt: now, archived: now }, { merge: true });
				});
				Vue.prototype.$posthog.capture('more_agreements_deleted', {
					agreement_id: agreementIds[i],
					user_id: store.state.user?.uid,
					role: store.state.posthogRole || '',
					email: store.state.user?.email,
				});
			}
			} catch (error) {
			  console.error(`There was a problem archiving agreements: ${error}`);
			}
		},
		async getPlans({ commit }) {
			const querySnapshot = await fb.plansCollection
				.where('active', '==', true)
				.get();

		// Use Promise.all to wait for ALL plans and their prices to load
		const planPromises = querySnapshot.docs.map(async (plan) => {
				const priceSnap = await plan.ref
					.collection('prices')
					.where('active', '==', true)
					.get();
				// Include document ID (which is the product ID) in plan data
				let planData = { 
					...plan.data(), 
					id: plan.id, // Document ID = Product ID
					product: plan.id, // Set product ID from document ID
					prices: [] 
				};

				priceSnap.docs.forEach((price) => {
					planData.prices = [
						...planData.prices,
						{ ...price.data(), id: price.id },
					];
				});

			return planData;
		});

		// Wait for ALL plans to be fully loaded with their prices
		const plans = await Promise.all(planPromises);

		// Commit ONCE with all complete data
		commit('setPlans', plans);
		commit('setPlansLoaded', true);
		},
		async getSubscriptions({ commit }, user) {
			const snapshot = await fb.customersCollection
				.doc(user.uid)
				.collection('subscriptions')
				.where('status', 'in', ['active'])
				.get();
			if (snapshot.empty) {
				return;
			}
			let subscriptions = [];

			snapshot.docs.forEach((subscription) => {
				subscriptions = [
					...subscriptions,
					{ ...subscription.data(), id: subscription.id },
				];
			});
			commit('setSubscriptions', subscriptions);
		},
		getPayments({ commit, state }, user) {
			if (state.paymentsUnsubscribe) {
				return Promise.resolve();
			}
			return new Promise((resolve) => {
				// Fetch only the latest succeeded payment (most recent plan) for party users
				const unsubscribe = fb.customersCollection
					.doc(user.uid)
					.collection('payments')
					.where('status', '==', 'succeeded')
					.orderBy('created', 'desc')
					.limit(1)
					.onSnapshot(async (snapshot) => {
						const doc = snapshot.docs[0];
						commit('setPayments', doc ? [{ ...doc.data(), id: doc.id }] : []);
						if (doc && state.userProfile?.requiresPayment) {
							await fb.usersCollection
								.doc(user.uid)
								.set({ requiresPayment: false }, { merge: true })
								.catch((error) => console.error('Could not clear requiresPayment:', error));
						}
						resolve();
					}, (error) => {
						console.error('Payments listener failed:', error);
						commit('setPayments', []);
						resolve();
					});
				commit('setUnsubscribePayments', unsubscribe);
			});
		},
		async updateEvent({ state, dispatch }, event) {
			const events = state.events;
			const eventIndex = events.findIndex(({ id }) => id == event.id);
			const updateScript =
				eventIndex > -1
					? {
							[eventIndex]: { $set: event },
					  }
					: {
							$push: [event],
					  };

			const tempEvents = update(events, updateScript);
			dispatch('updateEvents', tempEvents);

			return;
		},
		async deleteEvent({ state, dispatch }, event) {
			let events = state.events;
			let eventIndex = 0;
			// const eventIndex = events.findIndex(({ id }) => id == event.id);
			const eventNo = events.filter(({ eventNo }) => eventNo == event.eventNo);
			for(let i=0; i<eventNo.length;i++){
				events = state.events;
				if(eventNo[i] && eventNo[i].id){
					eventIndex = events.findIndex(({ id }) => id == eventNo[i].id);
				}
				const updateScript = {
					$splice: [[eventIndex, 1]],
				};
				
				const tempEvents = update(events, updateScript);
				dispatch('updateEvents', tempEvents);
			}
		},
		async updateEvents({ state, commit }, events) {
			commit('setSaving', true);
			commit('setEvents', events);
			try {
				await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('planner')
					.doc('schedule')
					.set({
						events,
					});

				setTimeout(() => {
					commit('setSaving', false);
				}, 500);
			} catch (error) {
				console.error('Something went wrong saving events');
			}
			return events;
		},
		async fetchEvents({ state, commit }) {
			try {
				const eventsRef = await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('planner')
					.doc('schedule')
					.get();
				if (eventsRef.exists) {
					const events = eventsRef.data();
					commit(
						'setEvents',
						events.events.map(({ start, end, ...rest }) => ({
							start: start.seconds ? start.toDate() : start,
							end: end.seconds ? end.toDate() : end,
							...rest,
						}))
					);
				} else {
					commit('setEvents', []);
				}
			} catch (error) {
				console.error('Error fetching events', error);
			}
		},
		async fetchEditedAgreement({ commit }, { id }) {
			try {
				const editedAgreement = await fb.agreementsCollection
					.doc(id)
					.collection('versions')
					.doc('editing')
					.get();
				if (editedAgreement.exists) {
					const agreement = editedAgreement.data();
					commit('setEditedAgreement', agreement.html);
				} else {
					commit('setEditedAgreement', null);
				}
			} catch (error) {
				console.error('Error fetching edited agreement', error);
			}
		},
		async fetchEditedAgreementWithDiscardedSuggestions({ commit }, { id }) {
			try {
				const editedAgreementWithDiscardedSuggestions = await fb.agreementsCollection
					.doc(id)
					.collection('versions')
					.doc('editingWithDiscardedSuggestions')
					.get();
				if (editedAgreementWithDiscardedSuggestions.exists) {
					const agreement = editedAgreementWithDiscardedSuggestions.data();
					commit('setEditedAgreementWithDiscardedSuggestions', agreement.html);
				} else {
					commit('setEditedAgreementWithDiscardedSuggestions', null);
				}
			} catch (error) {
				console.error('Error fetching edited agreement with discarded suggestions', error);
			}
		},
		async fetchEditedSummaryAgreement({ commit }, { id }) {
			try {
				const editedSummaryAgreement = await fb.agreementsCollection
					.doc(id)
					.collection('versions')
					.doc('summary')
					.get();
				if (editedSummaryAgreement.exists) {
					const agreement = editedSummaryAgreement.data();
					commit('setSummaryAgreement', agreement.html);
				} else {
					commit('setSummaryAgreement', null);
				}
			} catch (error) {
				console.error('Error fetching summary edited agreement', error);
			}
		},
		async fetchEditedSummaryAgreementWithDiscardedSuggestions({ commit }, { id }) {
			try {
				const editedSummaryAgreementWithDiscardedSuggestions = await fb.agreementsCollection
					.doc(id)
					.collection('versions')
					.doc('summaryWithDiscardedSuggestions')
					.get();
				if (editedSummaryAgreementWithDiscardedSuggestions.exists) {
					const agreement = editedSummaryAgreementWithDiscardedSuggestions.data();
					commit('setSummaryAgreementWithDiscardedSuggestions', agreement.html);
				} else {
					commit('setSummaryAgreementWithDiscardedSuggestions', null);
				}
			} catch (error) {
				console.error('Error fetching edited agreement with discarded suggestions', error);
			}
		},
		async fetchRevisions({ commit }, { id }) {
			try {
				const snapshot = await fb.agreementsCollection
					.doc(id)
					.collection('revisions')
					.orderBy('createdAt', 'asc')
					.get();

				const revisions = [];
				snapshot.forEach((doc) => {
					revisions.push({ id: doc.id, ...doc.data() });
				});
				commit('setRevisions', revisions);
				return revisions;
			} catch (error) {
				console.error('Error fetching revisions', error);
				return [];
			}
		},
		async fetchChildSupportTables({ commit }) { //removed "state," from this method.  
			try {
				const tablesSnap = await fb.realtimeDB
					.ref()
					.child('childSupport')
					.get();
				const tables = tablesSnap.val();
				commit('setChildSupportTables', tables);
			} catch (error) {
				console.error('could not fetch child support tables', error);
			}
		},
		async updateEditedAgreement({ state, commit }, agreementHtml) {
			commit('setEditedAgreement', agreementHtml);
			commit('setSaving', true);

			try {
				await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('versions')
					.doc('editing')
					.set({
						html: agreementHtml,
					});

				setTimeout(() => {
					commit('setSaving', false);
				}, 500);
			} catch (error) {
				console.error('Error saving edited agreement', error);
			}
		},
		async updateEditedSummaryAgreement({ state, commit }, agreementHtml) {
			commit('setSummaryAgreement', agreementHtml);
			commit('setSaving', true);

			try {
				await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('versions')
					.doc('summary')
					.set({
						html: agreementHtml,
					});

				setTimeout(() => {
					commit('setSaving', false);
				}, 500);
			} catch (error) {
				console.error('Error saving edited summary agreement', error);
			}
		},
		async updateEditedSummaryAgreementWithDiscardedSuggestions({ state, commit }, agreementHtml) {
			commit('setSummaryAgreementWithDiscardedSuggestions', agreementHtml);
			commit('setSaving', true);

			try {
				await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('versions')
					.doc('summaryWithDiscardedSuggestions')
					.set({
						html: agreementHtml,
					});

				setTimeout(() => {
					commit('setSaving', false);
				}, 500);
			} catch (error) {
				console.error('Error saving edited summary agreement with discarded suggestions', error);
			}
		},
		async updateEditedAgreementWithDiscardedSuggestions({ state, commit }, agreementHtml) {
			commit('setEditedAgreementWithDiscardedSuggestions', agreementHtml);
			commit('setSaving', true);

			try {
				await fb.agreementsCollection
					.doc(state.agreement.id)
					.collection('versions')
					.doc('editingWithDiscardedSuggestions')
					.set({
						html: agreementHtml,
					});

				setTimeout(() => {
					commit('setSaving', false);
				}, 500);
			} catch (error) {
				console.error('Error saving edited agreement with discarded suggestions', error);
			}
		},
		async fetchCurrentCustomerProfile({ state, commit }){
			try{
				const customer = state.user;
				if(customer && customer.uid) {
					let customerDetails = await fb.customersCollection.doc(customer.uid).get();
					if(customerDetails.data()){
						if(customerDetails.data()?.displayName != undefined && customerDetails.data()?.displayName !=null)
							customer.displayName = customerDetails.data().displayName;
						if(customerDetails.data()?.lastName != undefined && customerDetails.data()?.lastName !=null)
							customer.lastName = customerDetails.data().lastName;
						if(customerDetails.data()?.organizationName != undefined && customerDetails.data()?.organizationName !=null)
							customer.organizationName = customerDetails.data().organizationName;
						if(customerDetails.data()?.locationOfPractice != undefined && customerDetails.data()?.locationOfPractice !=null)
							customer.locationOfPractice = customerDetails.data().locationOfPractice;
						if(customerDetails.data()?.phoneNumber != undefined && customerDetails.data()?.phoneNumber !=null)
							customer.phoneNumber = customerDetails.data().phoneNumber;
						if(customerDetails.data()?.isSharedUser != undefined && customerDetails.data()?.isSharedUser !=null)
							customer.isSharedUser = customerDetails.data().isSharedUser;

						commit("setCustomerDetails", customerDetails.data())
					}
					commit('setUser', customer);
				}
			} catch (error) {
				console.error('Error fetch Current Customer Profile', error);
			}
		},
		async updateDisplayName(_, customer){
			// try {
				let custDetails = await fb.customersCollection.doc(customer.uid).get();
				if(custDetails?.exists){
					await fb.customersCollection.doc(customer.uid).set({
							displayName: customer.displayName,
					}, { merge: true });
				} else {
					await fb.customersCollection.doc(customer.uid).set({
						displayName: customer.displayName,
						email:customer.email
					});
				}
				// localStorage.setItem('displayName', customer.displayName);
				this.dispatch('fetchCurrentCustomerProfile');
			// } catch (error) {
			// 	console.error(error);
			// }
		},
		async updateLastName(_, customer){
			let custDetails = await fb.customersCollection.doc(customer.uid).get();
			if(custDetails?.exists){
				await fb.customersCollection.doc(customer.uid).set({
						lastName: customer.lastName,
				}, { merge: true });
			} else {
				await fb.customersCollection.doc(customer.uid).set({
					lastName: customer.lastName,
					email:customer.email
				});
			}
			// localStorage.setItem('userLastName', customer.lastName);
			this.dispatch('fetchCurrentCustomerProfile');
		},
		async updatePhoneNumber(_, customer){
			let custDetails = await fb.customersCollection.doc(customer.uid).get();
			if(custDetails?.exists){
				await fb.customersCollection.doc(customer.uid).set({
						phoneNumber: customer.phoneNumber,
				}, { merge: true });
			} else {
				await fb.customersCollection.doc(customer.uid).set({
					phoneNumber: customer.phoneNumber,
					email:customer.email
				});
			}
			// localStorage.setItem('phoneNumber', customer.phoneNumber);
			this.dispatch('fetchCurrentCustomerProfile');
		},
		async updateOrganizationName(_, customer){
				let custDetails = await fb.customersCollection.doc(customer.uid).get();
				if(custDetails?.exists){
					await fb.customersCollection.doc(customer.uid).set({
						organizationName: customer.organizationName,
					}, { merge: true });
				} else {
					await fb.customersCollection.doc(customer.uid).set({
						organizationName: customer.organizationName,
						email:customer.email
					});
				}
				// localStorage.setItem('organizationName', customer.organizationName);
				this.dispatch('fetchCurrentCustomerProfile');
		},
	// 	async updateLocationOfPractice(_, customer){
	// 		let custDetails = await fb.customersCollection.doc(customer.uid).get();
	// 		if(custDetails?.exists && customer){
	// 			await fb.customersCollection.doc(customer.uid).set({
	// 				locationOfPractice: customer.locationOfPractice,
	// 			}, { merge: true });
	// 		} else {
	// 			await fb.customersCollection.doc(customer.uid).set({
	// 				locationOfPractice: customer.locationOfPractice,
	// 				email:customer.email
	// 			});
	// 		}
	// 		// localStorage.setItem('locationOfPractice', customer.locationOfPractice);
	// 		this.dispatch('fetchCurrentCustomerProfile');
	// },
		async updateParentalPlannerTemplate({ state }, parentalPlannerTemplate) {
			try {
				await fb.agreementsCollection
					.doc(state.agreement.id)
					.set({
						parentalPlannerTemplate : parentalPlannerTemplate,
					}, { merge: true });
			} catch (error) {
				console.error('Something went wrong updating parenting planner template');
			}
			return parentalPlannerTemplate;
		},
		async getAllRoleLevels({ commit }){
			try{
				const getRoleLevels = fb.firebaseApp.functions('northamerica-northeast1').httpsCallable('publicApi-getRoleLevels');
				const { data } = await getRoleLevels();
				if (data.success) {
					commit('setAllRoleLevels', data.roleLevels);
				}
			} catch (error) {
				console.error('Error fetching role levels', error);
			}
		},
		async addUserRole({ state }, rolePermissions) {
			try {
				await authenticatedRequest('POST', '/addUserRole', {
					rolePermissions,
				});
			} catch (error) {
				console.error(error);
			}
		},
		async updateUserRole({ state }, rolePermission) {
			try {
				await authenticatedRequest('POST', '/updateUserRole', {
					rolePermission,
				});
			} catch (error) {
				console.error('Something went wrong editing user role');
			}
			return rolePermission;
		},
		async getUserRole({commit}) {
			try {
					let roleSnapShot=[];
					let refIds = [];
					await fb.roleLevelCollection.get()
					.then((snapChat)=>{
						snapChat.forEach((doc)=>{
							refIds.push(doc.id);
							roleSnapShot.push(doc.data());
						})
					});
					roleSnapShot = roleSnapShot.map((obj, index) => {
						obj.id = refIds[index];
						return obj;
					  });
					commit('setUserRole', roleSnapShot);
			} catch (error) {
				console.error('Something went wrong in getting user role');
			}
		},
		async deleteUserRole(_, roleId) {
			try {
				await authenticatedRequest('DELETE', `/deleteUserRole/${roleId}`);
			} catch (error) {
				console.error(
					`There was a problem deleting User Role ${roleId}`,
					error
				);
			}
		},
		setCurrentLoginPageAction({commit},pageNo){
			commit('setCurrentLoginPageNo',pageNo);
		},
		setCurrentSignUpPageAction({commit},pageNo){
			commit('setCurrentSignUpPageNo',pageNo);
		},
		setClientUserAgreementAction({commit},agreementId){
			commit('setClientUserAgreement',agreementId);
		}
		
	},
});

async function setRoleLevelForLoggedInUser(commit,state,user){
	let custDetails = await fb.customersCollection.doc(user.uid).get();
			// console.log('custDetails -===========>',custDetails.data());
			// console.log('roleLevels >>>>>>>',state.roleLevels);
			let roleDetails;
			if(state.roleLevels && state.roleLevels.length){
				if(custDetails && custDetails.data() && custDetails.data().roleLevel){
					roleDetails = state.roleLevels.find((role)=> role.roleName == custDetails.data().roleLevel);
				} else {
					// let roles = await fb.roleLevelCollection.where('roleName', '==', 'lawyer-level-1').get();
					// if(roles && roles.docs && roles.docs[0] && roles.docs[0].data()){
					// 	roleDetails = roles.docs[0];
					// }
					roleDetails = state.roleLevels.find((role)=> role.roleName == 'lawyer-level-1');
				}
				if(roleDetails){
					commit('setCurrentRoleLevel', roleDetails);
				}
			}
			// console.log('roleDetails -===========>',roleDetails);
}



export default store;
